"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWinstonContext = exports.resetWinstonContext = void 0;
const react_1 = __importDefault(require("react"));
const contextSymbol = typeof Symbol === 'function' && Symbol.for
    ? Symbol.for('__WINSTON_CONTEXT__')
    : '__WINSTON_CONTEXT__';
function resetWinstonContext() {
    Object.defineProperty(react_1.default, contextSymbol, {
        configurable: true,
        enumerable: false,
        value: react_1.default.createContext({}),
        writable: false
    });
}
exports.resetWinstonContext = resetWinstonContext;
function getWinstonContext() {
    if (!react_1.default[contextSymbol]) {
        resetWinstonContext();
    }
    return react_1.default[contextSymbol];
}
exports.getWinstonContext = getWinstonContext;
//# sourceMappingURL=WinstonContext.js.map